import { FC } from 'react';
import { Button, IconCode2, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useAlert } from 'contexts/alert/useAlert';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { ModuleContainer } from 'data/generated/graphql';
import { useGetDefaultCollection } from './collectionUtil';

interface AddCollectionProps {
  hierarchyId?: string;
  treatmentType?: string;
  disabled?: boolean;
}

export const AddCollection: FC<AddCollectionProps> = ({ treatmentType, hierarchyId, disabled = false }) => {
  const { modifyEntity } = useDataModelContext();
  const { alertError } = useAlert();

  const { getDefaultCollection } = useGetDefaultCollection();

  const isAddCollectionDisabled = disabled;

  const handleAddCollection = () => {
    try {
      const defaultCollection = getDefaultCollection(treatmentType);
      modifyEntity(hierarchyId!, (entity) => {
        const module = entity as ModuleContainer;

        module.collection = defaultCollection;
      });
    } catch (error) {
      if (error instanceof Error) {
        alertError(error.message);

        return;
      }

      alertError('An unexpected error occurred while adding the collection.');
    }
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button
          tertiary
          icon={IconCode2}
          onClick={handleAddCollection}
          disabled={isAddCollectionDisabled}
          data-testid="page-draft-add-collection"
        >
          Add collection
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
